import { render, staticRenderFns } from "./MailNotReceived.vue?vue&type=template&id=9f7b263c&"
import script from "./MailNotReceived.vue?vue&type=script&lang=js&"
export * from "./MailNotReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports